import { useWhatsappComercialModel } from '../../../modelos/Whatsapp/modeloWhatsappComercial';
import React, { useState, useEffect, useMemo } from 'react';
import EmbudoColumna from './componentes/EmbudoColumna';
import ContextMenu from '../../../components/ContextMenu';
import Modal from './utilsWhatsapp/modal';
import ChatComponent from './componentes/ChatComponent';
import ClienteContexto from './componentes/ClienteContexto';
import { ImagenModal } from './utilsWhatsapp/ImagenModal';
import { VideoModal } from './utilsWhatsapp/VideoModa';
import UserCard from './componentes/UserCard';

const columnConfig = {
    'NUEVO': { id: 'NUEVO', title: 'Inbox' },
    'COTIZANDO': { id: 'COTIZANDO', title: 'Cotizando' },
    'A PAGAR': { id: 'A PAGAR', title: 'Esperando Pago' },
    'PAGADO': { id: 'PAGADO', title: 'Pagado' }
    // Puedes agregar más columnas aquí como "SEGUIMIENTO", etc.
};

const EmbudoVentas = () => {
  const [chatActivoId, setChatActivoId] = useState(null);
  const [nuevoMensaje, setNuevoMensaje] = useState("");
  const [archivosEnvio, setarchivosEnvio] = useState({
    archivo: null,
  });
  const [isRecording, setIsRecording] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [columns, setColumns] = useState({});

  //busquedas
  const [terminoBusqueda, setTerminoBusqueda] = useState('');

  //modales
  // imagenes
  const [imagenEnModal, setImagenEnModal] = useState(null);
  const abrirModalImagen = (url) => setImagenEnModal(url);
  const cerrarModalImagen = () => setImagenEnModal(null);
  
  // videos
  const [videoEnModal, setVideoEnModal] = useState(null);
  const abrirModalVideo = (url) => setVideoEnModal(url);
  const cerrarModalVideo = () => setVideoEnModal(null);

  //vista actual
  const [vistaActual, setVistaActual] = useState('activos');

  //menu
  const [contextMenu, setContextMenu] = useState({
      visible: false,
      x: 0,
      y: 0,
      selectedChatId: null,
    });
  //menu context
  const handleContextMenu = (event, chatId) => {
    event.preventDefault(); // ¡Muy importante para prevenir el menú nativo del navegador!
    setContextMenu({
      visible: true,
      x: event.pageX, // Coordenada X del clic
      y: event.pageY, // Coordenada Y del clic
      selectedChatId: chatId,
    });
  };
  const handleCloseContextMenu = () => {
    setContextMenu({ ...contextMenu, visible: false });
  };

  //handle changes
  const { selectedChatId } = contextMenu;
  const handleChangeLabel = async (newLabel) => {

    await updateUsuario(selectedChatId,'label',newLabel);

    handleCloseContextMenu();
  };
  const handleArchivo = async (newArchivo) =>{

    await updateUsuario(selectedChatId,'archivo',true);

    handleCloseContextMenu();
  }
  const handleDesarchivo = async () => {
    if (!selectedChatId) return;
    await updateUsuario(selectedChatId, 'archivo', false);
    handleCloseContextMenu();
  };
  const menuOptions = useMemo(() => {
    if (vistaActual === 'activos') {
      return [
        { label: 'Marcar como Nuevo', action: () => handleChangeLabel('NUEVO') },
        { label: 'Marcar como Cotizando', action: () => handleChangeLabel('COTIZANDO') },
        { label: 'Marcar como A pagar', action: () => handleChangeLabel('A PAGAR') },
        { label: 'Marcar como Pagado', action: () => handleChangeLabel('PAGADO') },
        { type: 'divider' }, // Un separador para más claridad
        { label: 'Archivar Chat', action: handleArchivo, className: 'text-gray-500' },
      ];
    } else { // Menú para la vista de archivados
      return [
        { label: 'Desarchivar Chat', action: handleDesarchivo },
      ];
    }
  }, [vistaActual, selectedChatId]); 

  //ENVIO Y DEMAS
 const handleEnviarMensaje = async () => {
    if (nuevoMensaje.trim() === "" && !archivosEnvio.archivo) {
      return; 
    }
    
    setIsSending(true);
    console.log(`Enviando a chat ${chatActivoId}: "${nuevoMensaje}"`);
    
    try {
      
      await enviarMensaje(chatActivoId, nuevoMensaje, archivosEnvio);
      
      // ✅ Limpiar estados solo después del envío exitoso
     
      setNuevoMensaje("");
      setarchivosEnvio({ archivo: null });
      setIsRecording(false);
      
      console.log('✅ Mensaje enviado exitosamente');
      
    } catch (error) {
      console.error('❌ Error al enviar mensaje:', error);
    } finally{
      setIsSending(false);
    }
  };

  // ✅ Función específica para manejar audio
  const handleSendAudio = async (audioFile) => {
    console.log('📁 Archivo de audio recibido:', {
      name: audioFile.name,
      type: audioFile.type,
      size: audioFile.size
    });

    if (!chatActivoId) {
      console.error('❌ No hay chat activo seleccionado');
      setIsRecording(false);
      return;
    }

    try {
      // Enviar directamente el archivo de audio
      await enviarMensaje(chatActivoId, "", { archivo: audioFile });
      
      // ✅ Limpiar estados después del envío exitoso
      setarchivosEnvio({ archivo: null });
      setIsRecording(false);
      
      console.log('✅ Audio enviado exitosamente');
      
    } catch (error) {
      console.error('❌ Error al enviar audio:', error);
      // Limpiar estados en caso de error también
      setarchivosEnvio({ archivo: null });
      setIsRecording(false);
      // Aquí podrías mostrar un mensaje de error al usuario
    } finally {
      setIsSending(false); // Desbloqueamos la UI
    }
  };

  // ✅ Función para cancelar grabación
  const handleCancelRecording = () => {
    console.log('🚫 Grabación cancelada por el usuario');
    setIsRecording(false);
    setarchivosEnvio({ archivo: null });
  };

  // ✅ Función para iniciar grabación
  const handleStartRecording = () => {
    if (!chatActivoId) {
      console.warn('⚠️ No hay chat activo seleccionado');
      return;
    }
    console.log('🎤 Iniciando grabación de audio');
    setIsRecording(true);
  };

  const selectChatActivo = (idDelChatSeleccionado) => {
    console.log(`Cambiando al chat con ID: ${idDelChatSeleccionado}`);
    
    // ✅ Si hay una grabación en curso, cancelarla al cambiar de chat
    if (isRecording) {
      setIsRecording(false);
      setarchivosEnvio({ archivo: null });
    }
    
    setChatActivoId(idDelChatSeleccionado);
  };

  const {
      usuarios,
      idChatActualizado,
      setIdChatActualizado,
      loadingUsuarios,
      errorUsuarios,
      cargarTodosLosUsuarios,
  
      // mensajes
      mensajes,
      loadingmensajes,
      errormensajes,
      cargarTodosLosMensajes,
  
      enviarMensaje,
  
      updateUsuario
  } = useWhatsappComercialModel();

  const usuariosFiltrados = useMemo(() => {
    if (!usuarios) return [];
    
    // 1. Primero, filtra por estado de archivado (como antes)
    const estaArchivado = vistaActual === 'archivados';
    let listaFiltrada = usuarios.filter(u => u.archivo === estaArchivado);

    // 2. Luego, si hay un término de búsqueda, filtra esa lista de nuevo
    if (terminoBusqueda.trim() !== '') {
      const busquedaLowerCase = terminoBusqueda.toLowerCase();
      listaFiltrada = listaFiltrada.filter(u => 
        // Busca coincidencias en el nombre del usuario o en el número de teléfono
        (u.name && u.name.toLowerCase().includes(busquedaLowerCase)) ||
        (u.phone_number && u.phone_number.includes(busquedaLowerCase))
      );
    }

    return listaFiltrada;

  }, [usuarios, vistaActual, terminoBusqueda]); 

  useEffect(() => {
    const estaArchivado = vistaActual === 'archivados';

    cargarTodosLosUsuarios("DUFY ASESORIAS", estaArchivado);

  }, [vistaActual]);

  useEffect(() => {
    if (vistaActual === 'activos') {
        const newColumns = JSON.parse(JSON.stringify(columnConfig));
        Object.keys(newColumns).forEach(key => { newColumns[key].chats = []; });

        // Usa la lista ya filtrada
        usuariosFiltrados.forEach(user => {
            if (newColumns[user.label]) {
                newColumns[user.label].chats.push(user);
            } else if (newColumns['NUEVO']) {
                newColumns['NUEVO'].chats.push(user);
            }
        });
        setColumns(newColumns);
    } else {
        setColumns({});
    }
}, [usuariosFiltrados, vistaActual]);

  //CARGAR MENSAJES
  useEffect(() => {
            if (chatActivoId) {
                cargarTodosLosMensajes("DUFY ASESORIAS", chatActivoId);
            }
  }, [chatActivoId]);

  const chatActivo = usuarios.find(u => u.phone_number === chatActivoId);


  if (loadingUsuarios) return <div>Cargando embudo...</div>;

  return (
    <div className="flex h-screen font-sans bg-gray-50">

        <div className="w-full h-full p-4 flex flex-col">
  
          {/* 1. Un nuevo div para el encabezado que agrupa el título y los tabs */}
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold text-gray-800">Embudo de Ventas</h1>

            <div className="relative">
                  <input 
                      type="text"
                      placeholder="Buscar por nombre o número..."
                      value={terminoBusqueda}
                      onChange={(e) => setTerminoBusqueda(e.target.value)}
                      className="px-4 py-1.5 ... w-96" 
                  />
                  {/* Icono de Lupa (opcional pero recomendado) */}
                  <svg className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
              </div>

            {/* Las pestañas para cambiar de vista */}
            <div className="flex bg-gray-200 rounded-lg p-1">
              <button
                onClick={() => setVistaActual('activos')}
                className={`px-4 py-1 text-sm font-semibold rounded-md transition-colors duration-200 ${
                  vistaActual === 'activos' ? 'bg-white text-blue-600 shadow' : 'text-gray-600'
                }`}
              >
                Activos
              </button>
              <button
                onClick={() => setVistaActual('archivados')}
                className={`px-4 py-1 text-sm font-semibold rounded-md transition-colors duration-200 ${
                  vistaActual === 'archivados' ? 'bg-white text-blue-600 shadow' : 'text-gray-600'
                }`}
              >
                Archivados
              </button>
            </div>
          </div>

          {/* 2. El contenido va DENTRO del div principal, como un hermano del encabezado */}
          <div className="flex-grow overflow-y-auto">
            {vistaActual === 'activos' ? (
              <div className="flex gap-4 h-full">
                {Object.values(columns).map(column => (
                  <EmbudoColumna
                    key={column.id}
                    column={column}
                    chats={column.chats}
                    onCardContextMenu={handleContextMenu}
                    chatActivoId={chatActivoId}
                    onSetActivo={selectChatActivo}
                    idChatActualizado={idChatActualizado}
                  />
                ))}
              </div>
            ) : (
              // Vista para los chats archivados
              <div className="p-2">
                {usuariosFiltrados.map(chat => (
                    <UserCard
                        key={chat.phone_number}
                        chat={chat}
                        onContextMenu={handleContextMenu}

                        chatActivoId={chatActivoId} 
                        onSetActivo={selectChatActivo}
                        idChatActualizado={idChatActualizado}
                    />

                ))}
              </div>
            )}
          </div>
        </div>

        <Modal 
              isOpen={!!chatActivoId} 
              onClose={() => setChatActivoId(null)}
              listenForEscape={!imagenEnModal}
            >
                <div className="flex w-full h-full">
                    {/* Panel Izquierdo: El Chat */}
                    <div className="w-2/3 h-full">
                        <ChatComponent
                            chat={usuarios.find(u => u.phone_number === chatActivoId)}
                            onClose={() => setChatActivoId(null)}
                            mensajes={mensajes}
                            loadingMensajes={loadingmensajes}
                            nuevoMensaje={nuevoMensaje}
                            onNuevoMensajeChange={setNuevoMensaje}
                            archivosEnvio={archivosEnvio}
                            onArchivosEnvioChange={setarchivosEnvio}
                            isRecording={isRecording}
                            isSending={isSending}
                            onStartRecording={() => setIsRecording(true)}
                            onCancelRecording={() => setIsRecording(false)}
                            onEnviarMensaje={handleEnviarMensaje}
                            onEnviarAudio={handleSendAudio}
                            onAbrirImagen={abrirModalImagen}
                        />
                    </div>

                    <ClienteContexto chat={chatActivo} />

                </div>
                
        </Modal>
            
        {/* El menú contextual funciona sobre toda la página */}
        {contextMenu.visible && (
                <ContextMenu
                    x={contextMenu.x}
                    y={contextMenu.y}
                    options={menuOptions}
                    onClose={handleCloseContextMenu}
                />
        )}

        {/* Modales */}
        {imagenEnModal && (
                    <ImagenModal 
                      imageUrl={imagenEnModal} 
                      onClose={cerrarModalImagen} 
                    />
        )}

        {videoEnModal && (
                    <VideoModal 
                      videoUrl={videoEnModal} 
                      onClose={cerrarModalVideo} 
                    />
        )}

        </div>
    );

}

export default EmbudoVentas
